const $ = require('jquery');
window.$ = window.jQuery = $;
const urlUtilities = require('utilities/urlUtilities');
const util = require('utilities');
const storage = util.getLocalStorageOrObject();
const config = require('core/config');
const host = config.host;

require('headjs/dist/1.0.0/head.load');

//////////////////////
// Load Google Analytics
//////////////////////
const analyticsConfig = config.google.analytics;

if (analyticsConfig) {
	(function (w, d, s, l, i) {
		w[l] = w[l] || [];
		w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
		const f = d.getElementsByTagName(s)[0],
			j = d.createElement(s),
			dl = l != 'dataLayer' ? '&l=' + l : '';
		j.async = true;
		j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
		f.parentNode.insertBefore(j, f);
	})(window, document, 'script', 'dataLayer', analyticsConfig.id);
} else {
	// eslint-disable-next-line no-console
	console.log('Google Tag Manager not loaded');
}
// Load Events
$(document).ready(function () {
	// touch events will trigger "sticky" behavior of :hover elements on iOS,
	// so we'll "go fishing", we'll add a "not-touching" class to HTML
	// (similar to what modernizr would do) then when we detect a touchstart,
	// we'll remove the "not-touching" class from the HTML element
	// (we could use modernizr, but its tests are only for touch event
	// support, I think we want to wait until we see the user is actually using
	// touch events before we disable hover, this way if a user is using
	// (for example) a Chromebook but using a mouse we can leave :hover
	// "switched on")

	const touchDetected = function () {
		$(document).off('touchstart', touchDetected);
		$('html').addClass('touching');
	};
	$(document).on('touchstart', touchDetected);

	// Setup Vue app
	const Vue = require('vue');
	const readWorksVuePlugin = require('readworks-vue-plugin');
	Vue.use(readWorksVuePlugin);

	const vueApp = require('./vue-app');

	const testSuite = urlUtilities.getSearchParameter('rwsuite') || storage.rwTestSuite;

	if (host !== 'www.readworks.org' && testSuite) {
		window.head.load('/node_modules/mocha/mocha.js', function () {
			window.head.load('/assets/dist/scripts/ui/runner.js', function () {
				vueApp.$mount('#main-application');
			});
		});
	} else {
		delete storage.rwTestSuite;
		vueApp.$mount('#main-application');
	}
});
